import { render, staticRenderFns } from "./CustomerDetails.vue?vue&type=template&id=b67b00a6&scoped=true&"
import script from "./CustomerDetails.vue?vue&type=script&lang=js&"
export * from "./CustomerDetails.vue?vue&type=script&lang=js&"
import style0 from "./CustomerDetails.vue?vue&type=style&index=0&id=b67b00a6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b67b00a6",
  null
  
)

export default component.exports